import { render, staticRenderFns } from "./VouchersPage.vue?vue&type=template&id=116b04d8"
import script from "./VouchersPage.vue?vue&type=script&lang=js"
export * from "./VouchersPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports